// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__Ekzko","navlinks":"Navbar_navlinks__-E6h2","shopbtn":"Navbar_shopbtn__Fuptn"};